<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <div class="well">
      <div v-if="errors && errors.length" class="alert alert-danger row">
        <ul class="col">
          <li v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </div>

      <div class="row">
        <div class="col-sm-2">
          <div class="form-group">
            <p class="control-label">Current Link Status</p>
            <p>{{ linkStatus }}</p>
          </div>
        </div>

        <div class="col-sm-10">
          <div class="form-group">
            <p class="control-label">Current Link Address</p>
            <div class="input-group">
              <a :href="this.linkAddress" target="_blank" class="form-control  overflow-wrap">
                {{ this.linkAddress }}
              </a>
              <span class="input-group-btn">
                <button class="btn btn-primary" :id="copyLinkButtonId" type="button">Copy Link</button>
                <button class="btn btn-default" :id="copyTokenButtonId" type="button">Copy Token</button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-sm-4">
          <div v-if="editMode === 'activationDate'" class="form-group">
            <label for="edit-link-activation" class="control-label">
              Current Link Activation Date *
            </label>
            <input
              id="edit-link-activation"
              v-model="editedLink.activationDateString"
              :max="editedLink.expirationDateString"
              type="datetime-local"
              class="form-control"
            />
          </div>
          <div v-else class="form-group">
            <p class="control-label">
              Current Link Activation Date *
            </p>
            <p>
              {{ new Date(editedLink.activationDateString).toLocaleString() }} {{ timezoneAbbrev }}
              <!-- <button class="btn btn-xs btn-link" @click="setEditMode('activationDate')">
                <i class="fa fa-pencil" /> Edit
              </button> -->
            </p>
          </div>

          <div v-if="editMode === 'expirationDate'" class="form-group">
            <label for="edit-link-expiration" class="control-label">
              Current Link Expiration Date *
            </label>
            <input
              id="edit-link-expiration"
              v-model="editedLink.expirationDateString"
              :min="editedLink.activationDateString"
              type="datetime-local"
              class="form-control"
            />
          </div>
          <div v-else>
            <p class="control-label">
              Current Link Expiration Date *
            </p>
            <p>
              {{ new Date(editedLink.expirationDateString).toLocaleString() }} {{ timezoneAbbrev }}
             <!--  <button class="btn btn-xs btn-link" @click="setEditMode('expirationDate')">
                <i class="fa fa-pencil" /> Edit
              </button> -->
            </p>
          </div>

          <div v-if="editMode === 'licenseEndDate'" class="form-group">
            <label for="edit-link-license-end" class="control-label"> License End Date</label>
            <input
              v-if="editMode === 'licenseEndDate'"
              id="edit-link-license-end"
              v-model="editedLink.licenseEndDateString"
              type="date"
              class="form-control"
            />
          </div>
          <div v-else class="form-group">
            <p class="control-label"> License End Date</p>
            <p>
              {{ editedLink.licenseEndDateString }}
              <!-- <button class="btn btn-xs btn-link" @click="setEditMode('licenseEndDate')">
                <i class="fa fa-pencil" /> Edit
              </button> -->
            </p>
          </div>
        </div>

        <div class="col-sm-4">
          <div v-if="editMode === 'totalCapacity'" class="form-group">
            <label for="edit-link-total-capacity" class="control-label">
              Current Link Total Capacity
            </label>
            <input
              id="edit-link-total-capacity"
              v-model="editedLink.totalCapacity"
              type="number"
              min="1"
              class="form-control"
            />
          </div>
          <div v-else class="form-group">
            <p class="control-label">
              Current Link Total Capacity
            </p>
            <p>
              {{ editedLink.totalCapacity }}
              <!-- <button class="btn btn-xs btn-link" @click="setEditMode('totalCapacity')">
                <i class="fa fa-pencil" /> Edit
              </button> -->
            </p>
          </div>

          <div class="form-group">
            <p class="control-label">Current Link Used Capacity</p>
            <p>{{ editedLink.usedCapacity }}</p>
          </div>

          <div class="form-group">
            <p class="control-label">Current Link Remaining Capacity</p>
            <p>{{ editedLink.remainingCapacity }}</p>
          </div>
        </div>

        <div class="col-sm-4">
          <div v-if="editMode === 'notes'" class="form-group">
            <label for="edit-link-notes" class="control-label">Current Link Notes</label>
            <textarea
              id="edit-link-notes"
              class="form-control"
              rows="5"
              v-model="editedLink.notes"
            />
          </div>
          <div v-else class="form-group">
            <p class="control-label">Current Link Notes</p>
            <p>
              <pre class="notes">{{ editedLink.notes || '(none)' }}</pre>
              <button class="btn btn-xs btn-link" @click="setEditMode('notes')">
                <i class="fa fa-pencil" /> Edit
              </button>
            </p>
          </div>
        </div>
      </div>
      <p>
        <i>
          {{ timezoneMessage }}
        </i>
      </p>
      <p>
        <button
          class="btn btn-primary"
          :disabled="!isLinkEdited"
          @click="saveLink">
          Save
        </button>
      </p>
      <p class="text-muted">Last updated {{ updatedString }}</p>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import {
  getLinkValidationErrors,
  utcDateTimeStringFromLocalDateTimeString,
  dateTimeStringFromDateString,
} from './helpers'

export default {
  name: 'SignupLinkCurrent',
  props: {
    currentLink: {
      type: Object,
      required: false,
      default: null
    },
    timezoneAbbrev: {
      type: String,
      required: true
    },
    timezoneMessage: {
      type: String,
      required: true
    },
    linkStatus: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    domainUuid: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      editedLink: {},
      errors: [],
      clipboard: null,
      copyLinkButtonId: 'copy-link-button',
      copyTokenButtonId: 'copy-token-button',
      editMode: ''
    }
  },
  methods: {
    setEditMode(newMode) {
      this.editMode = newMode
    },
    saveLink() {
      const errors = getLinkValidationErrors(this.editedLink)
      this.errors = errors
      if (errors.length) {
        return
      }
      if (!this.confirmLinkExpirationOrUnactivation(this.currentLink, this.editedLink)) {
        return
      }
      this.editMode = ''
      const {
        activationDateString,
        expirationDateString,
        licenseEndDateString,
        totalCapacity,
        signupToken,
        notes
      } = this.editedLink
      this.errors = []
      this.$angularWorld.adminApi
        .putSignupLink({
          signup_token: signupToken,
          domain_uuid: this.domainUuid,
          activation_date: utcDateTimeStringFromLocalDateTimeString(activationDateString),
          expiration_date: utcDateTimeStringFromLocalDateTimeString(expirationDateString),
          license_end_date: dateTimeStringFromDateString(licenseEndDateString),
          total_capacity: Number(totalCapacity),
          updated_by: this.$angularWorld.auth.currentUser.uuid,
          notes,
        })
        .then(
          signupLink => {
            this.$emit('updatedLink', signupLink)
          },
          error => {
            this.errors.editedLink.push(error)
          }
        )
    },
    confirmLinkExpirationOrUnactivation(currentLinkObj, editedLinkObj) {
      if (
        this.isExpiringNonExpiredLink(
          currentLinkObj.expirationDateString,
          editedLinkObj.expirationDateString
        )
      ) {
        if (!confirm("Are you sure you want to expire this domain's current sign-up link?")) {
          return false
        }
      }
      if (
        this.isUnactivatingActivatedLink(
          currentLinkObj.activationDateString,
          editedLinkObj.activationDateString
        )
      ) {
        if (!confirm("This link is currently active. Are you sure you want to change the activation date so that it isn't currently active?")) {
          return false
        }
      }
      return true
    },
    isExpiringNonExpiredLink(currentExpirationDateString, editedExpirationDateString) {
      const editedLinkExpired = new Date(editedExpirationDateString) < new Date()
      if (!editedLinkExpired) {
        return false
      }
      const alreadyExpired = new Date(currentExpirationDateString) < new Date()
      return !alreadyExpired
    },
    isUnactivatingActivatedLink(currentActivationDateString, editedActivationDateString) {
      const currentLinkActivated = new Date(currentActivationDateString) < new Date()
      if (!currentLinkActivated) {
        return false
      }
      const editedLinkUnactivated = new Date(editedActivationDateString) > new Date()
      return editedLinkUnactivated
    }
  },
  computed: {
    isLinkEdited() {
      if (!this.currentLink) {
        return false
      }
      let keys = Object.keys(this.currentLink)
      return keys.some(key => {
        return this.editedLink[key] != this.currentLink[key]
      })
    },
    linkAddress() {
      return (
        this.currentLink &&
        `${this.$angularWorld.config.toolkitRoot}/accounts/ent_signup/${this.currentLink.signupToken}`
      )
    },
    updatedString() {
      return this.editedLink && `${new Date(this.editedLink.updatedAt).toString()}`
    }
  },
  created() {
    this.clipboard = new Clipboard(`#${this.copyLinkButtonId}`, { text: () => this.linkAddress })
    this.clipboard = new Clipboard(`#${this.copyTokenButtonId}`, { text: () => this.currentLink.signupToken })
  },
  beforeDestroy() {
    if (this.clipboard) {
      this.clipboard.destroy()
    }
  },
  watch: {
    currentLink(newCurrentLink) {
      this.editedLink = Object.assign({}, newCurrentLink)
    }
  },
  mounted() {
    if (this.currentLink) {
      this.editedLink = Object.assign({}, this.currentLink)
    }
  }
}
</script>

<style scoped>
.control-label {
  font-weight: 700;
}
.overflow-wrap {
  overflow-wrap: anywhere;
  height: fit-content;
}
.notes {
  border: none;
  font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}
</style>
